import React from "react";
import { Collapse } from "@mui/material";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { EntityType } from "../../../common/Common.types.ts";
import MentionInput from "../../../common/components/mentionInput/MentionInput.tsx";
import SystemAIRadioGroup from "./SystemAIRadioGroup.tsx";
import { isNullOrWhitespace } from "../../../common/stringOperations.ts";

export interface SystemAIFieldProps {
    usesAI: boolean;
    companyUsesAIService: boolean;
    aiUsageDescription: string | undefined;
    isUseOfAIConsideredHighRisk: boolean;
    isDataUsedForTraningOfAIModel: boolean;
    systemId: string;
    onUsesAIChange: (value: boolean) => void;
    onCompanyUsesAIServiceChange: (value: boolean) => void;
    onAiUsageDescriptionChange: (value: string) => void;
    onIsUseOfAIConsideredHighRiskChange: (value: boolean) => void;
    onIsDataUsedForTraningOfAIModelChange: (value: boolean) => void;
    readOnly?: boolean;
    disabled: boolean;
    isPreview: boolean;
    errorText?: string;
}

function SystemAIField(props: SystemAIFieldProps) {
    const { translateString } = useTranslation();

    return (
        <>
            <SystemAIRadioGroup
                isChecked={props.usesAI}
                onCheckedChange={props.readOnly ? () => {} : props.onUsesAIChange}
                isReadOnly={props.disabled}
                label={translateString("assetUseAI")}
            />
            <Collapse in={props.isPreview || props.usesAI}>
                <SystemAIRadioGroup
                    isChecked={props.companyUsesAIService}
                    onCheckedChange={props.readOnly ? () => {} : props.onCompanyUsesAIServiceChange}
                    isReadOnly={props.disabled}
                    label={translateString("companyUsesAIProvidedByAsset")}
                />

                <Collapse in={props.isPreview || props.companyUsesAIService}>
                    <MentionInput
                        debounce={!props.readOnly}
                        value={props.aiUsageDescription ?? ""}
                        label={translateString("descriptionOfAIUsage")}
                        multiline
                        rows={5}
                        disabled={props.disabled}
                        onChange={props.readOnly ? () => {} : props.onAiUsageDescriptionChange}
                        {...(isNullOrWhitespace(props.systemId)
                            ? { disableMentions: true as const }
                            : { mentionSource: { entityFromId: props.systemId, entityFromType: EntityType.System } })}
                    />
                    <SystemAIRadioGroup
                        isChecked={props.isUseOfAIConsideredHighRisk}
                        onCheckedChange={props.readOnly ? () => {} : props.onIsUseOfAIConsideredHighRiskChange}
                        isReadOnly={props.disabled}
                        label={translateString("useOfAIConsideredHighRisk")}
                    />
                    <SystemAIRadioGroup
                        isChecked={props.isDataUsedForTraningOfAIModel}
                        onCheckedChange={props.readOnly ? () => {} : props.onIsDataUsedForTraningOfAIModelChange}
                        isReadOnly={props.disabled}
                        label={translateString("isDataUsedForTraningOfAIModel")}
                    />
                </Collapse>
            </Collapse>
        </>
    );
}

export default SystemAIField;
